module.exports = __webpack_public_path__ + "3cdece0285a2f7b80ace8e631c7aa288.png";